<template>
  <el-dialog 
    :title="$t('housekeepingResource.editResource')" 
    :visible.sync="visible"
    width="70%"
    @close="closeDialog"
  >
    <el-form :model="editHousekeepingResourceInfo" label-width="120px" :rules="rules" ref="form">
      <el-form-item :label="$t('housekeepingResource.resourceType')" prop="resTypeId">
        <el-select 
          v-model="editHousekeepingResourceInfo.resTypeId" 
          @change="setEditResTypeName"
          style="width:100%"
        >
          <el-option 
            v-for="item in editHousekeepingResourceInfo.resourceStoreTypes"
            :key="item.rstId"
            :label="item.name"
            :value="item.rstId"
          ></el-option>
        </el-select>
      </el-form-item>

      <el-form-item :label="$t('housekeepingResource.resourceName')">
        <el-input v-model="editHousekeepingResourceInfo.resName"></el-input>
      </el-form-item>

      <el-form-item :label="$t('housekeepingResource.resourceCode')">
        <el-input v-model="editHousekeepingResourceInfo.resCode"></el-input>
      </el-form-item>

      <el-form-item :label="$t('housekeepingResource.costPrice')" prop="costPrice">
        <el-input v-model.number="editHousekeepingResourceInfo.costPrice" type="number"></el-input>
      </el-form-item>

      <el-form-item :label="$t('housekeepingResource.salePrice')" prop="price">
        <el-input v-model.number="editHousekeepingResourceInfo.price" type="number"></el-input>
      </el-form-item>

      <el-form-item :label="$t('housekeepingResource.stock')" prop="stock">
        <el-input v-model.number="editHousekeepingResourceInfo.stock" type="number"></el-input>
      </el-form-item>

      <el-form-item :label="$t('housekeepingResource.supplier')" prop="supplierId">
        <el-select 
          v-model="editHousekeepingResourceInfo.supplierId" 
          @change="setEditSupplierName"
          style="width:100%"
        >
          <el-option 
            v-for="item in editHousekeepingResourceInfo.resourceSuppliers"
            :key="item.rsId"
            :label="item.supplierName"
            :value="item.rsId"
          ></el-option>
        </el-select>
      </el-form-item>

      <el-form-item :label="$t('housekeepingResource.description')">
        <el-input 
          type="textarea" 
          v-model="editHousekeepingResourceInfo.remark"
          :rows="3"
        ></el-input>
      </el-form-item>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">{{ $t('common.cancel') }}</el-button>
      <el-button type="primary" @click="editHousekeepingResource">{{ $t('common.save') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { updateHousekeepingResource, listResourceStoreTypes, listResourceSuppliers } from '@/api/housekeepingResource/housekeepingResourceApi'
import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'EditHousekeepingResource',
  data() {
    return {
      visible: false,
      editHousekeepingResourceInfo: {
        resId: '',
        resTypeId: '',
        resTypeName: '',
        resourceStoreTypes: [],
        resName: '',
        resCode: '',
        costPrice: '',
        price: '',
        stock: '',
        supplierId: '',
        supplierName: '',
        resourceSuppliers: [],
        remark: '',
        configId: '',
        shopId: getShopId()
      },
      rules: {
        resTypeId: [
          { required: true, message: this.$t('housekeepingResource.requiredResourceType'), trigger: 'blur' }
        ],
        costPrice: [
          { required: true, message: this.$t('housekeepingResource.requiredCostPrice'), trigger: 'blur' },
        ],
        price: [
          { required: true, message: this.$t('housekeepingResource.requiredSalePrice'), trigger: 'blur' },
        ],
        stock: [
          { required: true, message: this.$t('housekeepingResource.requiredStock'), trigger: 'blur' },
        ],
        supplierId: [
          { required: true, message: this.$t('housekeepingResource.requiredSupplier'), trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    open(row) {
      this.visible = true
      this.editHousekeepingResourceInfo = {
        ...row,
        resourceStoreTypes: this.editHousekeepingResourceInfo.resourceStoreTypes,
        resourceSuppliers: this.editHousekeepingResourceInfo.resourceSuppliers
      }
      this._listEditResourceStoreTypes()
      this._listEditResourceSuppliers()
    },
    closeDialog() {
      this.visible = false
      this.$refs.form.resetFields()
    },
    async editHousekeepingResource() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          try {
            await updateHousekeepingResource(this.editHousekeepingResourceInfo)
            this.$emit('refresh')
            this.$message.success(this.$t('common.saveSuccess'))
            this.closeDialog()
          } catch (error) {
            this.$message.error(error)
            console.error(error)
          }
        }
      })
    },
    async _listEditResourceStoreTypes() {
      try {
        const res = await listResourceStoreTypes({
          page: 1,
          row: 50,
          shopId: getShopId()
        })
        this.editHousekeepingResourceInfo.resourceStoreTypes = res.data
      } catch (error) {
        console.error(error)
      }
    },
    async _listEditResourceSuppliers() {
      try {
        const res = await listResourceSuppliers({
          page: 1,
          row: 50,
          shopId: getShopId()
        })
        this.editHousekeepingResourceInfo.resourceSuppliers = res.data
      } catch (error) {
        console.error(error)
      }
    },
    setEditResTypeName(value) {
      const type = this.editHousekeepingResourceInfo.resourceStoreTypes.find(item => item.rstId === value)
      if (type) {
        this.editHousekeepingResourceInfo.resTypeName = type.name
      }
    },
    setEditSupplierName(value) {
      const supplier = this.editHousekeepingResourceInfo.resourceSuppliers.find(item => item.rsId === value)
      if (supplier) {
        this.editHousekeepingResourceInfo.supplierName = supplier.supplierName
      }
    }
  }
}
</script>